import React from 'react'

const Review = props => {
    const data = props.data;

    const selectedOptions = data.options.filter((el, i) => props.selected[i])

    const handleNextClick = () => {
       console.log("restart course" );
        props.onComplete();
    }

    return (
        <div className="Review">
         
                  <div className="top-half">
                {/* header */}
                <div className="left">
                    <h1 className={`header`} dangerouslySetInnerHTML={{ __html: data.review.header }}></h1>
        
                    <div className={`before-choices`}dangerouslySetInnerHTML={{ __html: data.review.beforeChoices }}></div>
                    
                    {
                    data.options &&
                    <div className={'options'}>
                        {selectedOptions.map((option, optionIndex) => {
                                return <div className={`option`}><div className="inline-block">{option}</div></div>
                            })        
                        }
                    </div>
                }

                </div>
                {/* <div className="right"> */}
                    <div className={`after-choices`}dangerouslySetInnerHTML={{ __html: data.review.afterChoices }}></div>

                    <div className={`byte-link`}dangerouslySetInnerHTML={{ __html: data.review.byteLink }}></div>   

                    

                {/* </div> */}
                <div className="bottom-banner">
                    <div className="next-button global-button" onClick={()=>handleNextClick()}>Next</div>                   
                </div>

          </div>            
        </div>
    )
}

export default Review